// Recording aid, not a user feature. Visiting `?set_masking=yes` anonymises every
// chain name and logo in the UI for a few hours, so a demo video can be filmed
// without naming retailers (agreed with Halo Inspektore — see docs/golive.md).
//
// It only ever *removes* information: no price is altered. The flag expires on its
// own so a forgotten activation can't keep hiding the chain names the app exists
// to show. Not linked from anywhere.

const STORAGE_KEY = 'maskMode'
const DEFAULT_HOURS = 6

export function isMaskingActive() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return false
    const { until } = JSON.parse(raw) ?? {}
    if (typeof until !== 'number') return false
    if (until <= Date.now()) {
      localStorage.removeItem(STORAGE_KEY) // don't leave expired keys around
      return false
    }
    return true
  } catch {
    return false
  }
}

export function setMasking(on, hours = DEFAULT_HOURS) {
  try {
    if (on) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ until: Date.now() + hours * 3600 * 1000 }))
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    /* ignore */
  }
}

// Reads `?set_masking=yes|no`. Returns true when the flag changed state, so the
// caller can re-render. Any other value is ignored rather than guessed at.
export function applyMaskingFromUrl(search) {
  const raw = search ?? (typeof window === 'undefined' ? '' : window.location.search)
  const value = new URLSearchParams(raw).get('set_masking')
  if (value === 'yes') {
    setMasking(true)
    return true
  }
  if (value === 'no') {
    setMasking(false)
    return true
  }
  return false
}
